import { Box, Image } from '@wix/design-system'
import React, { FC, memo } from 'react'

import { WixStudioSidePanelText } from '../../../reusable/WixStudioSidePanelText'
import { WixStudioTemplateSidePanel } from '../../../reusable/WixStudioTemplate/WixStudioTemplateSidePanel'
import s from './SidePanel.scss'

export const SidePanel: FC<{ image: string; text: string; dataHook?: string }> = memo(
  ({ image = 'none', text, dataHook }) => (
    <WixStudioTemplateSidePanel className={s.root} dataHook={dataHook}>
      <Box width="70%">
        <Image src={image} style={{ background: 'transparent' }} />
      </Box>
      <Box maxWidth="72%" opacity={text ? 1 : 0}>
        <WixStudioSidePanelText text={text} />
      </Box>
    </WixStudioTemplateSidePanel>
  ),
)
